import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sbnb-property-detail-number-edit-boolean-edit',
  templateUrl: './property-detail-number-edit-boolean-edit.component.html',
  styleUrls: ['./property-detail-number-edit-boolean-edit.component.scss'],
})
export class PropertyDetailNumberEditBooleanEditComponent {
  @Input() label: string;
  @Input() edited: boolean;
  @Input() hasAirbnbListing: boolean;
  @Input() hasBookingListing: boolean;
  @Input() value: boolean;

  @Output() updated: EventEmitter<any> = new EventEmitter();
}
